import PropTypes from 'prop-types';

const GeneralInfoPropType = PropTypes.shape({
    firstName: PropTypes.string,
    language: PropTypes.string,
    lastName: PropTypes.string,
    locale: PropTypes.string,
    phone: PropTypes.string,
    phoneCountryCode: PropTypes.string,
    timezone: PropTypes.string,
});

export default GeneralInfoPropType;
